// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading___29D3j","loadingWp":"loadingWp___3Lv1i","loadingText":"loadingText___3Jltz"};